import { FieldInputEvent } from "@lib/types";
import { LitElement, TemplateResult } from "lit";
import { customElement, property, query } from "lit/decorators.js";
import { inputFieldTemplate } from "./inputFIeld.html";

const fieldCss = new CSSStyleSheet();
fieldCss.insertRule(`
    .input-container-inner.disabled.error {
        border-color: #d72d30;
    }
`);

/** Input field component. */
@customElement("ms4-input-field")
export class InputField extends LitElement {

    @property({ type: String })
    public accessor class = "";

    @property({ type: String })
    public accessor type = "";

    @property({ type: String })
    public accessor label = "";

    @property({ type: String })
    public accessor value = "";

    @property({ type: String })
    public accessor errorText = "";

    @property({ type: String })
    public accessor state: "error" | "normal" = "normal";

    @property({ type: Boolean })
    public accessor disabled = false;

    @query("fw-input")
    private accessor fieldElement: HTMLElement;

    /** @inheritdoc */
    public render(): TemplateResult {
        return inputFieldTemplate.call(this);
    }

    /** @inheritdoc */
    protected firstUpdated(): void {
        this.fieldElement.shadowRoot?.adoptedStyleSheets.push(fieldCss);
    }

    /**
     * Handles field input.
     * @param event Field input event.
     */
    protected onFieldInput(event: FieldInputEvent): void {
        this.dispatchEvent(new CustomEvent("input", {
            detail: event,
        }));
    }
}
